import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import _ from 'lodash';
import AppConstants, { CHANGE_EVENT } from '../constants/AppConstants';
import PaymentsConstants from '../constants/PaymentsConstants';
import ManagePaymentsApiUtils from '../utils/ManagePaymentsApiUtils';

let paymentData = null;
let _cancelPaymentResponse = null;
let _editPaymentResponse = null;
let backUrl;

class EditPaymentsStore_new extends EventEmitter {
  constructor() {
    super();
    this.dispatchToken = AppDispatcher.register(
      this.dispatcherCallback.bind(this)
    );
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }
  getPaymentData() {
    return paymentData;
  }
  getBackUrl() {
    return backUrl;
  }
  getVerificationType() {
    return _.get(_editPaymentResponse, 'error.verification_type', '');
  }
  getEditPaymentResponse() {
    return _editPaymentResponse;
  }
  getCancelPaymentResponse() {
    return _cancelPaymentResponse;
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  reset() {}
  dispatcherCallback(data) {
    const actionType = data.action.actionType;
    const actionData = data.action.data;
    switch (actionType) {
      case AppConstants.LOGOUT_USER:
        this.reset();
        break;
      case PaymentsConstants.SET_EDIT_PAYMENT_DATA:
        paymentData = actionData;
        break;
      case PaymentsConstants.DELETE_PAYMENT_DETAILS:
        ManagePaymentsApiUtils.cancelPayment(actionData);
        break;
      case PaymentsConstants.DELETE_PAYMENT_RESPONSE:
        _cancelPaymentResponse = actionData;
        this.emitChange();
        break;
      case PaymentsConstants.EDIT_SO_PAYMENT_SERVICECALL:
        const accountId = actionData.accountId;
        const mandateId = actionData.mandateId;
        const editData = actionData.editPaymentRequest;
        const isSameSourceId = actionData.isSameSourceId;

        ManagePaymentsApiUtils.editPayment(
          editData,
          accountId,
          mandateId,
          isSameSourceId
        );
        break;
      case PaymentsConstants.EDIT_PAYMENT_SERVICE_MESSAGE:
        _editPaymentResponse = actionData;
        this.emitChange();
        break;
      case PaymentsConstants.SET_EDIT_PAYEMENT_BACK_URL:
        backUrl = actionData;
        break;
      default: {
        break;
      }
    }
  }
}
export default new EditPaymentsStore_new();
